import styled from 'styled-components';

export const Separator = styled.div`
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #161718;
`;